import styled from "styled-components";
import placeholder from '../images/placeholder-image.webp'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import 'swiper/css'
import { GoStarFill } from "react-icons/go";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TbStairsUp } from "react-icons/tb";



const CarouselRooms = ({rooms, setRooms}) => {

      const {t} = useTranslation();
      rooms.sort((a, b) => (b.images ? 1 : 0) - (a.images ? 1 : 0));
    // Quando è chiuso basta rimuovere il mese indicato
  // const months = ['aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre'];


  // const handleChange = (room, value) => {

  //   setRooms((prev) =>
  //     prev.map((r) =>
  //       r.id === room.id ? { ...r, selected: value } : r
  //     )
  //   );
  // };





    return (
    <Wrapper>
    <div className="container">
      <div className="row">
        {rooms.map((room) => {
          return (
            <div key={room.id} className="col-12 col-md-4">
              <div className="card">
                <Swiper
                  className="swiper-wrapper"
                  modules={[Pagination]}
                  pagination={{ clickable: true }}
                  spaceBetween={20}
                  slidesPerView={1}
                >
                  {
                    room.favorite ? 
                    <div className="favorite">
                      <GoStarFill className="icon" />
                      <div className="favoriteText">{t('preferito')}</div>
                    </div>
                    : 
                    null
                  }
                  {room.images ? (
                    room.images.map((image, index) => (
                      <SwiperSlide key={index}>
                        <img src={image} alt="" />
                      </SwiperSlide>
                    ))
                  ) : (
                    <SwiperSlide>
                      <img src={placeholder} alt="" />
                    </SwiperSlide>
                  )}
                </Swiper>
                <div className="body">
                  <div className="header">
                    <div className="title">{room.name}</div>
                    {room.stairs ? <div className="floor"><TbStairsUp className="icon" /></div> : null}

                  </div>
                  {/* {!room.selected ? <div className="price">{t('select')}</div> : (
                    <div className="price">{t('da')} {room.options[room.selected]}€ {t('aNotte')}</div>
                  )} */}
                  <div className="row fotografie">
                    {/* <select
                      onChange={(e) => handleChange(room, e.target.value)}
                      className="selectMonth"
                    >
                        {
                          months.map((month, index) => {
                            return <option value={month} key={index}>{t(month)}</option>
                          })
                        }
                    </select> */}
                    {
                      room.images ? 
                        <Link className="link" to={`/rooms/${room.id}`}>{t('vediFoto')}</Link> 
                      : 
                      null
                    }
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </Wrapper>
  )
}

export default CarouselRooms

const Wrapper = styled.section`
.fotografie {
  padding-top: 20px;
  justify-content: center !important;
  .link {
    width: 100%;
    text-align: center;
  } 
}
  /* margin: 40px 0px; */
  .col-12 {
    padding: 25px 10px;
    .card {
      height: 375px;
      padding-top: 250px;
      position: relative;
      .swiper-wrapper {
        position: absolute;
        height: 250px;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        .favorite {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 12px;
          padding: 6px 8px;
          background-color: var(--gray);
          border-radius: 10px;
          z-index: 50;
          .icon {
            color: orange;
          }
          .favoriteText {
            padding-left: 4px;
            font-weight: bold;
          }
        }
        img {
          border-radius: 10px;
          object-fit: cover;
          object-position: center;
          height: 100%;
          width: 100%;
        }
      }
      .body {
        padding: 5px;
        .header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 5px 0px;

          .floor {
            .icon {
              display: block;
              height: 100%;
              font-size: 24px;
              color: var(--logo);
            }

          }
          .title {
            font-size: 20px;
            font-weight: bold;
          }
        }
        .price {
          padding: 5px 0px 10px;
        }
        .row {
          align-items: center;
          justify-content: space-between;
          .selectMonth {
            appearance: none;
            border: 0;
            outline: 0;
            font-size: 16px;
            font-family: "Quicksand", sans-serif;
            text-transform: capitalize;
            width: 100px;
            padding: 5px 7px;
            cursor: pointer;
            border-radius: 5px;
            color: white;
            background-color: var(--logo);
          }
          .link {
            background-color: white;
            border: 1px solid var(--logo);
            padding: 5px 10px 5px 5px;
            border-radius: 5px;
            color: var(--logo);
          }
        }
      }
    }
  }
`;
